export const CLOTHING_CATEGORIES = [
  'shirt',
  'dress',
  'pants',
  'skirt',
  'jacket',
  'coat',
  'sweater',
  'blouse',
  'top',
  'jeans',
  'shorts',
  'suit',
  'blazer',
  'hoodie',
  't-shirt',
  'tshirt',
  'sweatshirt',
  'cardigan',
  'vest',
  'jumpsuit',
  'outerwear',
] as const;
